import React, { useEffect, useRef, useState } from 'react';
import { layout, colors } from '../../styles/designTokens';

// Shield Icon - מגן עם V - שנה אחריות (חלול)
const ShieldIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    style={style}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>
);

// Trophy Icon - גביע - איכות ללא מתחרים
const TrophyIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    style={style}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0" />
  </svg>
);

// Lines Icon - קווים מקבילים - 4 מסרקי הגבהה
const LinesIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    style={style}
  >
    <path d="M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z" />
  </svg>
);

// Sparkles Icon - כוכבים - קל לניקוי
const SparklesIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    style={style}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
  </svg>
);

// Knife Icon - סכין
const KnifeIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    style={style}
  >
    <path fillRule="evenodd" d="M8.128 9.155a3.751 3.751 0 1 1 .713-1.321l1.136.656a.75.75 0 0 1 .222 1.104l-.006.007a.75.75 0 0 1-1.032.157 1.421 1.421 0 0 0-.113-.072l-.92-.531Zm-4.827-3.53a2.25 2.25 0 0 1 3.994 2.063.756.756 0 0 0-.122.23 2.25 2.25 0 0 1-3.872-2.293ZM13.348 8.272a5.073 5.073 0 0 0-3.428 3.57 5.08 5.08 0 0 0-.165 1.202 1.415 1.415 0 0 1-.707 1.201l-.96.554a3.751 3.751 0 1 0 .734 1.309l13.729-7.926a.75.75 0 0 0-.181-1.374l-.803-.215a5.25 5.25 0 0 0-2.894.05l-5.325 1.629Zm-9.223 7.03a2.25 2.25 0 1 0 2.25 3.897 2.25 2.25 0 0 0-2.25-3.897ZM12 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clipRule="evenodd" />
    <path d="M16.372 12.615a.75.75 0 0 1 .75 0l5.43 3.135a.75.75 0 0 1-.182 1.374l-.802.215a5.25 5.25 0 0 1-2.894-.051l-5.147-1.574a.75.75 0 0 1-.156-1.367l3-1.732Z" />
  </svg>
);

interface FeatureItem {
  text: string;
  renderIcon: (style?: React.CSSProperties) => React.ReactNode;
  iconAnimationClass?: string;
}

const FeatureTicker: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  // בדיקה אם הפס גלוי במסך - לחיסכון באנרגיה
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features: FeatureItem[] = [
    { 
      text: 'איכות ללא מתחרים', 
      renderIcon: (style) => <TrophyIcon style={style} />,
      iconAnimationClass: ''
    },
    { 
      text: 'שנה אחריות על ידי היבואן', 
      renderIcon: (style) => <ShieldIcon style={style} />,
      iconAnimationClass: ''
    },
    { 
      text: 'סכין ייחודית לתספורת עדינה', 
      renderIcon: (style) => <KnifeIcon style={style} />,
      iconAnimationClass: ''
    },
    { 
      text: '4 מסרקי הגבהה לבחירה', 
      renderIcon: (style) => <LinesIcon style={style} />,
      iconAnimationClass: ''
    },
    { 
      text: 'קל לניקוי', 
      renderIcon: (style) => <SparklesIcon style={style} />,
      iconAnimationClass: ''
    },
  ];

  const duplicatedFeatures = [...features, ...features];

  return (
    <section 
      ref={sectionRef}
      id="advantages" 
      className="relative overflow-hidden"
      style={{ 
        background: colors.accentSpecial.buttonGradientDiagonal,
        paddingTop: 'clamp(10px, 1.2vw, 16px)',
        paddingBottom: 'clamp(10px, 1.2vw, 16px)',
        direction: 'rtl',
        overflowX: 'hidden',
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <div className="container mx-auto" style={{ maxWidth: layout.contentMaxWidth, paddingLeft: 'clamp(12px, 2vw, 20px)', paddingRight: 'clamp(12px, 2vw, 20px)' }}>
        <div 
          className="feature-ticker-wrapper relative"
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <div 
            className="feature-ticker-content inline-flex items-center"
            style={{
              animation: isVisible ? 'tickerScroll 10s linear infinite' : 'none', // קצב אופטימלי - לא מהיר מדי ולא איטי מדי
              gap: 'clamp(1rem, 2.2vw, 1.75rem)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.animationPlayState = 'paused';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.animationPlayState = 'running';
            }}
          >
            {duplicatedFeatures.map((feature, index) => (
              <div
                key={`${feature.text}-${index}`}
                className="feature-item inline-flex items-center"
                style={{
                  flexShrink: 0,
                  gap: 'clamp(0.75rem, 1.8vw, 1.25rem)',
                }}
              >
                <div
                  className="feature-icon-wrapper icon-gentle-pulse"
                  style={{
                    width: 'clamp(28px, 3.5vw, 40px)',
                    height: 'clamp(28px, 3.5vw, 40px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#000000',
                    position: 'relative',
                  }}
                >
                  {feature.renderIcon({ width: '100%', height: '100%' })}
                </div>
                <span
                  className="feature-text font-bold"
                  style={{
                    fontSize: 'clamp(1.0rem, 2vw, 1.6rem)',
                    whiteSpace: 'nowrap',
                    color: '#000000',
                  }}
                >
                  {feature.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureTicker;
